import React from 'react';
import styled from 'styled-components';

import UsageMainOptionsBar from '../../containers/usage/UsageMainOptionsBar';
import { charts, views } from '../../constants/event';
import UsageTablePane from '../../containers/usage/UsageTablePane';
import UsageLabelsPane from '../../containers/labels/UsageLabelsPane';
import EventChart from '../../chart/EventChart';

const StyledUsageMainPane = styled.div`
  overflow: auto;
  flex-grow: 1;
  height: 100%;

  .usage-main-pane-wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px 0;
  }
`;

const UsageMainPane = (props) => {
  const { options } = props;

  return (
    <StyledUsageMainPane>
      <div className="usage-main-pane-wrapper">
        <UsageMainOptionsBar />
        <div style={{ marginTop: 20 }}>
          {charts.includes(options.view) && (
            <div>
              <div style={{ height: '400px' }}>
                <EventChart {...props} />
              </div>
              <div className="st-labels-chart">
                <UsageLabelsPane />
              </div>
            </div>
          )}
          {options.view === views.TABLE && <UsageTablePane />}
        </div>
      </div>
    </StyledUsageMainPane>
  );
};

export default UsageMainPane;
